import { render, staticRenderFns } from "./Sectors.vue?vue&type=template&id=9c5aea92&scoped=true&"
import script from "./Sectors.vue?vue&type=script&lang=js&"
export * from "./Sectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5aea92",
  null
  
)

export default component.exports